import React, { useMemo, useState } from 'react';
import { useLocaleContext } from '../../../context/LocaleContext';
import { motion } from 'framer-motion';
import { CButton, CSearch } from '../../UI';

import './style.scss';

const FiltersSearch = ({value, onSearch}) => {
    const $locale = useLocaleContext();
    const [isSearchActive, setSearchActive] = useState(false);

    const variants = useMemo(() => {
        const activeWidth = window.innerWidth > 600 ? window.innerWidth / 2 : window.innerWidth - 20;

        return {
            hidden: {
                opacity: 0,
                width: 0,
            },
            visible: {
                opacity: isSearchActive ? 1 : 0,
                width: isSearchActive ? activeWidth : 0,
            },
        }
    }, [isSearchActive]);

    return (
        <div className="schedule-filter-search">
            <motion.div
                initial="hidden"
                animate="visible"
                variants={variants}
                className="schedule-filter-search-field"
                onDragTransitionEnd={{
                    display: isSearchActive ? 'block' : 'none',
                }}
            >
                <CSearch
                    value={value}
                    isActive={isSearchActive}
                    onSearch={onSearch}
                    onClose={() => setSearchActive(false)}
                />
            </motion.div>
            {
                !!value &&
                <CButton
                    blank
                    icon={!!value ? 'close' : 'search'}
                    className="search-button"
                    onClick={() => onSearch('')}
                />
            }
            <CButton
                blank
                icon={!!value ? '' : 'search'}
                className="search-button"
                label={$locale.get('label.search')}
                onClick={() => setSearchActive(!isSearchActive)}
            />
        </div>
    )
};

export default FiltersSearch;
